import React from 'react';
import {
  Flex, Link, useAuthenticator, useTheme,
} from '@aws-amplify/ui-react';

function SignInFooter() {
  const { toResetPassword } = useAuthenticator();
  const { tokens } = useTheme();

  return (
    <Flex justifyContent="center" padding={`0 0 ${tokens.space.medium}`}>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Link style={{ color: 'black' }} onClick={toResetPassword}>Reset your password</Link>
    </Flex>
  );
}

export default SignInFooter;
